/**
=========================================================
* IDP - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the IDP are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// IDP layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Documents from "layouts/documents";
import DocumentParser from "layouts/document-parser";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import DocumentTypeEditor from "layouts/document-type-editor";
import DocumentDetail from "layouts/document-approval/DocumentDetail";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    icon: <Icon fontSize="small">folder</Icon>,
    route: "/documents",
    component: <Documents />,
  },
  {
    type: "collapse",
    name: "Document Parser",
    key: "document-parser",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/document-parser",
    component: <DocumentParser />,
  },
  {
    type: "collapse",
    name: "Document Types",
    key: "document-types",
    icon: <Icon fontSize="small">edit_document</Icon>,
    route: "/document-types",
    component: <DocumentTypeEditor />,
  },
  {
    type: "route",
    key: "document-approval-detail",
    route: "/document-approval/:id",
    component: <DocumentDetail />,
  },
];

export default routes;
